<div class="search-results-container">
  <inexp-breadcrumbs class="search-breadcrumbs" [items]="breadcrumbs" />

  <!-- Active Filters -->
  @if (activeFilters().length > 0) {
    <div class="active-filters">
      <span class="ui-body-l-bold">Active filters:</span>
      @for (filter of activeFilters(); track filter.value) {
        <span class="active-filter-chip">
          {{ filter.display }}
          <button
            class="remove-filter"
            (click)="removeFilter(filter)"
            [attr.aria-label]="'Remove filter ' + filter.display"
          >
            &times;
          </button>
        </span>
      }
      <button rds-secondary-button size="s" (click)="clearAllFilters()">
        Clear all
      </button>
    </div>
  }

  <div class="search-content">
    @if (showFullSkeleton()) {
      <inexp-search-result-skeleton />
    } @else {
    <!-- Filter Sidebar -->
    @if (displayAggregations().length > 0) {
      <aside class="filter-sidebar">
        <h2 class="ui-heading-3">{{ SEARCH_RESULT_TEXTS.FILTERS_HEADING }}</h2>

        @for (aggregation of displayAggregations(); track aggregation.name) {
          <div class="filter-group">
            <div class="filter-group-header">
              <span class="ui-body-m-bold">{{
                getAggregationDisplayName(aggregation.name)
              }}</span>
            </div>

            <div class="filter-group-items">
              @for (item of getVisibleItems(aggregation); track item.value) {
                <label
                  class="filter-item"
                  [class.is-disabled]="item.disabled"
                  [attr.title]="
                    item.disabled ? 'No results with the current filters' : null
                  "
                >
                  <input
                    type="checkbox"
                    [checked]="isFilterActive(aggregation.name, item.value)"
                    [disabled]="item.disabled"
                    (change)="toggleFilter(aggregation, item)"
                  />
                  <span class="filter-item-label">{{
                    getItemDisplay(item)
                  }}</span>
                  <span class="filter-item-count">({{ item.count }})</span>
                </label>
              }
            </div>

            <!-- Show more/less toggle only if more than 5 items -->
            @if (hasMoreItems(aggregation)) {
              <button
                class="show-more-toggle"
                (click)="toggleAggregation(aggregation.name)"
              >
                @if (isAggregationExpanded(aggregation.name)) {
                  <span>− Show less</span>
                } @else {
                  <span
                    >+ Show {{ getHiddenItemsCount(aggregation) }} more</span
                  >
                }
              </button>
            }
          </div>
        }
      </aside>
    }

    <!-- Results Area -->
    <main id="main-content" class="results-area" [class.is-busy]="sinequaService.loading()">
      <!-- Persistent live region: announces refine progress/completion to SRs. -->
      <div class="sr-only" aria-live="polite">
        @if (sinequaService.loading()) {
          Updating results
        } @else if (searchResults()) {
          Found {{ searchResults().totalRowCount || 0 }} results
        }
      </div>

      @if (sinequaService.loading()) {
        <div class="results-busy-overlay" aria-hidden="true">
          <rds-progress-spinner mode="indeterminate" size="m" />
        </div>
      }
      @if (sinequaService.error()) {
        <div class="error">
          <p>Error: {{ sinequaService.error() }}</p>
        </div>
      }
      @if (searchResults()) {
        <div class="results">
          <div class="results-header">
            <h1 class="ui-heading-2 results-title">{{ resultsHeading() }}</h1>

            <!-- Only the sorts Sinequa actually honours. `date` is accepted by
                 the API and echoed back, but returns relevance order, so
                 "Recently added" is left out rather than shipped as a control
                 that silently does nothing. -->
            <div class="results-sort">
              <!-- The label sits outside the field box, as drawn. Setting
                   the label position to inline would push it inside the
                   border. -->
              <span id="results-sort-label" class="results-sort-label">
                Sort by
              </span>
              <rds-form-field labelPosition="none">
                <rds-select
                  aria-labelledby="results-sort-label"
                  [ngModel]="sortBy()"
                  (ngModelChange)="onSortChange($event)"
                >
                  @for (option of SORT_OPTIONS; track option.value) {
                    <rds-select-option [value]="option.value">
                      {{ option.label }}
                    </rds-select-option>
                  }
                </rds-select>
              </rds-form-field>
            </div>
          </div>

          <!-- The agent's reading of the query, above the results it comments
               on. The topic only moves on a real text search (or on the
               category a mega-menu entry landed with), so refining by filter or
               paging does not re-run it. -->
          <inexp-assistant-widget
            *inexpFeatureFlag="'panorama_inexp_2498_assistant'"
            [summaryPrompt]="assistantSummaryPrompt()"
            [followUpContext]="assistantContext()"
            [openingQuestion]="assistantTopic()"
          />

          @if (searchResults().records && searchResults().records.length > 0) {
            <div class="formatted-results">
              @for (result of searchResults().records; track result.slug) {
                <inexp-offering-card
                  [displayName]="result.title"
                  [slug]="result.slug"
                  [approvalStatus]="result.approvalStatus"
                  [description]="result.summary || result.description"
                  [descriptionHtml]="getMatchHighlights(result)"
                />
              }
            </div>
          } @else {
            <div class="no-results">
              <p>No results found for your search.</p>
            </div>
          }

          @if (totalResults() > PAGE_SIZE) {
            <rds-paginator
              class="pagination"
              [length]="totalResults()"
              [pageSize]="PAGE_SIZE"
              [pageIndex]="currentPage()"
              showFirstLastButtons
              hidePageSize
              (page)="handlePageEvent($event)"
            >
            </rds-paginator>
          }
        </div>
      }
      @if (searchQuery() === null) {
        <div class="no-query">
          <p class="ui-body-l">
            No search query provided. Please use the search form.
          </p>
        </div>
      }
    </main>
    }
  </div>
</div>
